import React, { useRef, useState } from "react";
import { Dialog, DialogContent, DialogTitle, DialogDescription } from "./ui/dialog";
import { ExpandIcon } from "./BrandIcons";
import screens from "../lib/product-screen-references.json";

export const DecisionScreenGallery = () => {
  const [selected, setSelected] = useState(1);
  const [open, setOpen] = useState(false);
  const tabs = useRef([]);
  const screen = screens[selected];
  const handleKeys = (event, index) => {
    const next = { ArrowRight: (index + 1) % screens.length, ArrowLeft: (index + screens.length - 1) % screens.length, Home: 0, End: screens.length - 1 }[event.key];
    if (next === undefined) return;
    event.preventDefault();
    setSelected(next);
    tabs.current[next]?.focus();
  };

  return <div data-testid="brain-screen-gallery">
    <div className="decision-screen-tabs" role="tablist" aria-label="Helios Brain product views" data-testid="brain-screen-tabs">
      {screens.map((item, index) => <button
        key={item.id} ref={element => { tabs.current[index] = element; }}
        id={`brain-tab-${item.id}`} role="tab" aria-selected={index === selected}
        aria-controls="brain-screen-panel" tabIndex={index === selected ? 0 : -1}
        data-testid={`brain-screen-tab-${item.id}`} onClick={() => setSelected(index)}
        onKeyDown={event => handleKeys(event, index)}
      ><span aria-hidden="true">0{index + 1}</span>{item.label}</button>)}
    </div>
    <div id="brain-screen-panel" role="tabpanel" aria-labelledby={`brain-tab-${screen.id}`} tabIndex={0} data-testid="brain-screen-panel">
      <figure className="brain-product-figure">
        <img data-testid="brain-product-map-image" src={screen.image} alt={screen.alt} width="1487" height="1070" loading="lazy" />
        <figcaption>
          <span data-testid="brain-screen-caption">{screen.caption}</span>
          <button data-testid="brain-expand-screen" className="campaign-text-link" onClick={() => setOpen(true)} title="Enlarge product screen"><ExpandIcon size={18} />View full screen</button>
        </figcaption>
      </figure>
    </div>
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent data-testid="brain-screen-dialog" className="product-screen-dialog">
        <DialogTitle data-testid="brain-screen-dialog-title">Helios Brain · {screen.label}</DialogTitle>
        <DialogDescription data-testid="brain-screen-dialog-description">Product concept with illustrative data, not a live customer decision.</DialogDescription>
        <img data-testid="brain-screen-expanded-image" src={screen.image} alt={screen.alt} />
        <a href={screen.original} data-testid="brain-screen-original-link" target="_blank" rel="noopener noreferrer">Open original image ↗</a>
      </DialogContent>
    </Dialog>
  </div>;
};